module.exports = __webpack_public_path__ + "img/sortImg1-4.51a25927.png";